// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item_root__hnrSa {
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid var(--mui-palette-grey-400);
  padding: 12px 16px;
  box-shadow: 0 8px 16px 0 #4985C81F;
  margin-bottom: 6px;
}

.item_viewDetailsButtonIcon__vu3ik {
  fill: var(--mui-palette-grey-400);
}`, "",{"version":3,"sources":["webpack://./src/components/manage-restaurants/list/map/list/item.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".root {\n  cursor: pointer;\n  border-radius: 6px;\n  border: 1px solid var(--mui-palette-grey-400);\n  padding: 12px 16px;\n  box-shadow: 0 8px 16px 0 #4985C81F;\n  margin-bottom: 6px;\n}\n\n.viewDetailsButtonIcon {\n  fill: var(--mui-palette-grey-400);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `item_root__hnrSa`,
	"viewDetailsButtonIcon": `item_viewDetailsButtonIcon__vu3ik`
};
export default ___CSS_LOADER_EXPORT___;
